import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostHK2024/layout/Component/FormTitle';
import FormInput from '@src/mobile/phtvHostHK2024/layout/Component/FormInput';
import FormSelect from '@src/mobile/phtvHostHK2024/layout/Component/FormSelect';
import FormWaring from '@src/mobile/phtvHostHK2024/layout/Component/FormWaring';
import FormTextarea from '@src/mobile/phtvHostHK2024/layout/Component/FormTextarea';
import { zhanden } from '@src/utils/zhanden';

const Required = ({ formData, setFormDataHandle, warningTextList, languages }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.onlineSignUp}>
            <div className={styles.formList}>
                <div className={styles.formListBox}>
                    {/* 姓名 */}
                    <FormTitle name="name" title={zhanden[languages].name.title} warningText={warningTextList['name']} isRequired={true} />
                    <FormInput name="name" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['name']} />
                    {/* 性别 */}
                    <FormTitle name="gender" title={zhanden[languages].gender.title} warningText={warningTextList['gender']} isRequired={true} />
                    <FormSelect
                        name="gender"
                        formData={formData}
                        changeInputHandle={changeInputHandle}
                        optionValueList={[zhanden[languages].gender.man, zhanden[languages].gender.woman]}
                        languages={languages}
                    />
                    <FormWaring warningText={warningTextList['gender']} />
                    {/* 年龄 */}
                    <FormTitle title={zhanden[languages].age.title} name="age" warningText={warningTextList['age']} isRequired={true} />
                    <FormInput name="age" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['age']} />
                    {/* 教育程度 */}
                    <FormTitle
                        title={zhanden[languages].education.title}
                        name="education_level"
                        warningText={warningTextList['education_level']}
                        isRequired={true}
                    />
                    <FormInput name="education_level" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['education_level']} />
                    {/* 国家或地区 */}
                    <FormTitle name="country_or_region" title={zhanden[languages].country.title} warningText={warningTextList['country_or_region']} isRequired={true} />
                    <FormInput name="country_or_region" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['country_or_region']} />
                    {/* 所持证件 */}
                    <FormTitle name="documents" title={zhanden[languages].documents.title} warningText={warningTextList['documents']} isRequired={true} />
                    <FormSelect
                        name="documents"
                        formData={formData}
                        changeInputHandle={changeInputHandle}
                        optionValueList={[
                            zhanden[languages].documents.hkid,
                            zhanden[languages].documents.Passport,
                            zhanden[languages].documents.work,
                            zhanden[languages].documents.other,
                        ]}
                        languages={languages}
                    />
                    <FormWaring warningText={warningTextList['documents']} />
                    {/* 是否熟悉中文 */}
                    <FormTitle name="familiar_chinese" title={zhanden[languages].hasChinese.title} warningText={warningTextList['familiar_chinese']} isRequired={true} />
                    <FormTextarea
                        formData={formData}
                        placeholder={zhanden[languages].hasChinese.placeholder}
                        name="familiar_chinese"
                        changeInputHandle={changeInputHandle}
                    />
                    <FormWaring warningText={warningTextList['familiar_chinese']} />
                    {/* 联络方式 */}
                    <FormTitle
                        name="contact_details"
                        title={zhanden[languages].contact.title}
                        warningText={warningTextList['contact_details']}
                        isRequired={true}
                    />
                    <FormInput
                        name="contact_details"
                        formData={formData}
                        placeholder={zhanden[languages].contact.placeholder}
                        changeInputHandle={changeInputHandle}
                    />
                    <FormWaring warningText={warningTextList['contact_details']} />
                </div>
            </div>
        </div>
    );
};

Required.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    languages: PropTypes.string
};

export default errorBoundary(Required);
